import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-05.jpg";
import aiImg from "../../assets/img/ai-WISvec.png";
import aiIcon01 from "../../assets/img/icon-ai12.png";
import aiIcon02 from "../../assets/img/icon-ai15.png";
import aiIcon03 from "../../assets/img/icon-ai03.png";
import aiIcon04 from "../../assets/img/icon-ai01.png";
import fwImg from "../../assets/img/fw-wisvec.png";

function WISvec() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

  //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISvec 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">AI 벡터 검색 솔루션</span>
						<h2>WISvec</h2>
						<p>텍스트·이미지·음성 등 멀티모달 데이터를 벡터화하여 저장하고 의미기반 검색을 지원해주는 Neuro Search 엔진입니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISvec 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISvec" /></div>
            <div className="info">
              <p>WISvec은 텍스트, 이미지 등 다양한 형태의 데이터를 고차원 벡터로 임베딩(Embedding)하여, 사용자의 자연어 질의나 예제 데이터와 의미적으로 가장 유사한 정보를 빠르고 정확하게 검색하는 차세대 AI 검색 엔진입니다.<br/>기존 키워드 기반 검색의 한계를 극복하고, 데이터 내재 의미를 반영한 의미 기반 유사도 검색이 가능한 것이 가장 큰 특징입니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">고성능 임베딩 생성</p>
                  <p className="txt">다양한 딥러닝/멀티모달 모델을 활용해 문서, 이미지, 오디오 등 각종 데이터를 벡터로 변환</p>
                </li>
                 <li>
                  <p className="tit">벡터 DB 인덱싱 및 저장</p>
                  <p className="txt">효율적인 대용량 벡터 저장을 위한 전문 벡터DB 연동 및 초고속 유사도 탐색 지원</p>
                </li>
                 <li>
                  <p className="tit">의미 기반 유사도 검색</p>
                  <p className="txt">사용자의 질의(질문, 예시, 문장 등)를 벡터화해 DB 내 벡터들과의 유사도를 계산하여 가장 관련성 높은 결과를 반환</p>
                </li>
                 <li>
                  <p className="tit">멀티모달 데이터 유연 지원</p>
                  <p className="txt">텍스트, 이미지, 소리 등 다양한 입력 데이터 타입 지원</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="의미 기반 검색"/></span>
              <p className="tit">의미 기반<br/>검색</p>
              <p className="txt">다국어 멀티모달 임베딩 엔진을 통한 의미기반 검색 지원</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="대규모 데이터 처리"/></span>
              <p className="tit">대규모 데이터<br/>처리</p>
              <p className="txt">대규모 데이터 저장과 관리를 위해 설계된 벡터 DB를 통한 대용량, 고성능 데이터 처리 </p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="다중 데이터 유형"/></span>
              <p className="tit">다중 데이터<br/>유형</p>
              <p className="txt">다국어 텍스트, 이미지 등 멀티모달 임베딩 엔진을 통한 유연한 벡터화 지원</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="맞춤형 임베딩 지원"/></span>
              <p className="tit">맞춤형 <br/> 임베딩 지원</p>
              <p className="txt">도메인/기업별 맞춤 임베딩 모델 적용 및 파인튜닝</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">데이터 수집</p>
                <p className="txt">텍스트/이미지 등 원본데이터 수집</p>
              </li>
              <li>
                <p className="tit">임베딩 생성</p>
                <p className="txt">딥러닝모델 활용 ⇒ 고차원 벡터로 변환</p>
              </li>
              <li>
                <p className="tit">벡터 인덱싱</p>
                <p className="txt">생성된 벡터를 벡터DB에 인덱싱</p>
              </li>
              <li>
                <p className="tit">임베딩 변환</p>
                <p className="txt">사용자 질의 ⇒ 쿼리 벡터로 변환</p>
              </li>
              <li>
                <p className="tit">유사도 검색</p>
                <p className="txt">벡터 공간에서 관련 정보를 검색</p>
              </li>
              <li>
                <p className="tit">검색 결과</p>
                <p className="txt">API/검색 UI에 반환</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework">
              <img src={fwImg} alt="WISvec 프레임워크" onClick={imgClick} />
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">검색엔진</p>
                <p className="txt">기존 텍스트 기반 검색을 넘어 이미지, 음성 등 다양한 콘텐츠 검색이 가능</p>
              </li>
                <li>
                <p className="tit">생성형 AI</p>
                <p className="txt">검색 결과를 기반으로 답변을 생성하는 RAG 시스템의 핵심 기술</p>
              </li>
                <li>
                <p className="tit">의료・금융 분야</p>
                <p className="txt">질병 진단, 신약 개발, 이상 거래 탐지, 신용 평가 등에 활용</p>
              </li>
              <li>
                <p className="tit">고객 지원</p>
                <p className="txt">챗봇, FAQ 검색 등에 활용</p>
              </li>
              <li>
                <p className="tit">지리 공간 분석</p>
                <p className="txt">지리 정보 시스템 및 위치 기반 서비스에서 효율적인 공간 검색 분석을 수행</p>
              </li>
              <li>
                <p className="tit">동영상 및 이미지 검색</p>
                <p className="txt">이미지와 비디오 임베딩이 벡터로 저장되어, 시각적으로 유사한 이미지나 비디오를 검색</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISvec;